import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import _ from "underscore";
import { gettext } from "web/script/modules/django-i18n";
import { getHtmlProps } from "web/script/modules/html-tag-props";
import { ShippingOptionPropType } from "web/types/buy-option";
import SVGIcon from "../svg-icon/svg-icon";
import LeadLink from "../lead-link/lead-link";
import style from "./shipping.css";


function Shipping({
    className,
    expressShipping,
    freeReturn,
    freeShipping,
    freeShippingUrl,
    isSavedForLater,
    leadUrl,
    retailerName,
}) {
    const seeMoreOnSpanProps = {
        class: style.seeMoreOn,
    };
    const seeMoreOnRetailerSpanProps = {
        class: style.link,
    };
    // we escape retailerName, and so mark this string as available for dangerouslySetInnerHTML
    const seeMoreOnRetailerSafeHtml = {
        __html: gettext("in_stock_product.see_more_on_retailer.in_spans", {
            see_more_span_props: getHtmlProps(seeMoreOnSpanProps),
            retailer_name_span_props: getHtmlProps(seeMoreOnRetailerSpanProps),
            retailer_name: _.escape(retailerName),
        }),
    };

    return (
        <div className={classnames(className, style.wrapper)}>
            {freeShipping && (
                <div className={style.freeShipping}>
                    <div className={style.icon}>
                        <SVGIcon name="truck" />
                    </div>
                    {freeShippingUrl ? (
                        <a
                            className={style.shippingLabel}
                            href={freeShippingUrl}
                            dangerouslySetInnerHTML={{ __html: freeShipping.html_message }}
                        />
                    ) : (
                        <span
                            className={style.shippingLabel}
                            dangerouslySetInnerHTML={{ __html: freeShipping.html_message }}
                        />
                    )}
                </div>
            )}
            {expressShipping && (
                <div className={style.expressShipping}>
                    <div className={style.icon}>
                        <SVGIcon name="stopwatch" />
                    </div>
                    <span className={style.shippingLabel}>
                        {gettext("in_stock_product.express_shipping_label")}
                    </span>
                </div>
            )}
            {freeReturn && (
                <div className={style.freeReturn}>
                    <div className={style.icon}>
                        <SVGIcon name="tick-new" />
                    </div>
                    <span className={style.shippingLabel}>
                        {gettext("in_stock_product.free_returns_label")}
                    </span>
                </div>
            )}
            <div className={style.linkHolder}>
                <LeadLink reason="retailer-link" href={leadUrl} isSavedForLater={isSavedForLater}>
                    <span dangerouslySetInnerHTML={seeMoreOnRetailerSafeHtml} />
                </LeadLink>
                <SVGIcon name="round-chevron" />
            </div>
        </div>
    );
}

export default Shipping;

Shipping.propTypes = {
    className: PropTypes.string,
    expressShipping: ShippingOptionPropType,
    freeReturn: PropTypes.bool,
    freeShipping: ShippingOptionPropType,
    freeShippingUrl: PropTypes.string,
    isSavedForLater: PropTypes.bool,
    leadUrl: PropTypes.string,
    retailerName: PropTypes.string,
};

Shipping.defaultProps = {
    expressShipping: null,
    freeReturn: false,
    freeShipping: null,
    isSavedForLater: false,
};
